// extracted by mini-css-extract-plugin
export default {"parent":"App_parent__aTWdI","child":"App_child__wAKm-"};